import { Emphasis } from './emphasis';

export type Risk = 'LOW' | 'MEDIUM' | 'HIGH';

export const isRisk = (x: any): x is Risk =>
  x === 'LOW' || x === 'MEDIUM' || x === 'HIGH';

export type ExtendedRisk = Risk | 'VERY_HIGH';

export const isExtendedRisk = (x: any): x is ExtendedRisk =>
  isRisk(x) || x === 'VERY_HIGH';

/** Emphasis of a risk level, which gives its chip colour: low grey, medium yellow, high and very high red. */
export const RISK_EMPHASIS: Record<ExtendedRisk, Emphasis> = {
  LOW: Emphasis.INSIGNIFICANT,
  MEDIUM: Emphasis.IMPORTANT,
  HIGH: Emphasis.CRUCIAL,
  VERY_HIGH: Emphasis.CRUCIAL
};
